<div tabindex="0" role="button" class="modal-overlay" *ngIf="visible" (click)="onCancel()" (keyup.enter)="onCancel()" (keyup.space)="onCancel()">
  <div class="lp-modal confirm-delete-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" [attr.aria-label]="'Delete ' + itemType" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

    <div class="lp-modal-header">
      <h3>{{ mode === 'archive' ? 'Remove' : 'Delete' }} {{ itemType | titlecase }}{{ isBulk ? 's' : '' }}</h3>
      <button class="lp-modal-close" (click)="onCancel()" data-tooltip="Close" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </button>
    </div>

    <div class="lp-modal-body">

      <div class="cdm-warning-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <line x1="12" y1="17" x2="12.01" y2="17" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </div>

      <p class="cdm-item-name">{{ displayName }}</p>
      <p class="cdm-prompt" *ngIf="message">{{ message }}</p>
      <p class="cdm-prompt" *ngIf="mode === 'both'">Choose how to delete {{ isBulk ? 'these' : 'this' }} {{ itemType }}{{ isBulk ? 's' : '' }}:</p>
      <p class="cdm-prompt" *ngIf="mode === 'permanent'">{{ isBulk ? 'These' : 'This' }} {{ itemType }}{{ isBulk ? 's' : '' }} will be permanently deleted. This cannot be undone.</p>
      <p class="cdm-prompt" *ngIf="mode === 'archive'">{{ isBulk ? 'These' : 'This' }} {{ itemType }}{{ isBulk ? 's' : '' }} will be removed and can be restored later.</p>

      <div class="cdm-choices" *ngIf="mode === 'both'">
        <label class="cdm-choice" [class.selected]="choice === 'archive'">
          <input type="radio" name="deleteChoice" value="archive" [(ngModel)]="choice" />
          <div class="cdm-choice-body">
            <span class="cdm-choice-title">Archive (Soft Delete)</span>
            <span class="cdm-choice-desc">Move to archived status. Can be restored later.</span>
          </div>
        </label>

        <label class="cdm-choice" [class.selected]="choice === 'permanent'">
          <input type="radio" name="deleteChoice" value="permanent" [(ngModel)]="choice" />
          <div class="cdm-choice-body">
            <span class="cdm-choice-title">Permanently Delete</span>
            <span class="cdm-choice-desc">This cannot be undone. {{ itemType | titlecase }}{{ isBulk ? 's' : '' }} will be removed forever.</span>
          </div>
        </label>
      </div>

    </div>

    <div class="lp-modal-footer">
      <button class="lp-btn lp-btn-cancel" (click)="onCancel()">Cancel</button>
      <button class="lp-btn lp-btn-warning" *ngIf="choice === 'archive'" (click)="confirm()">
        {{ mode === 'archive' ? 'Remove' : 'Archive' }} {{ itemType | titlecase }}{{ isBulk ? 's' : '' }}
      </button>
      <button class="lp-btn lp-btn-danger" *ngIf="choice === 'permanent'" (click)="confirm()">
        Delete Permanently
      </button>
    </div>

  </div>
</div>
